// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"10":"cddd8260","67":"91bf3cb2","171":"f22fcdbd","212":"e2d2a0f0","365":"0b53b5e4","499":"52452bc2","537":"0bc6ba4b","546":"7c15187b","751":"3337f491"}[chunkId] + ".chunk.css";
};